/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "../app/@shared/ui/modal/modal.component.ngfactory";
import * as i2 from "../app/@shared/ui/modal/modal.component";
import * as i3 from "../app/@shared/ui/modal/modal.service";
import * as i4 from "./compat.component";
var styles_CompatComponent = [];
var RenderType_CompatComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_CompatComponent, data: {} });
export { RenderType_CompatComponent as RenderType_CompatComponent };
export function View_CompatComponent_0(_l) { return i0.ɵvid(0, [i0.ɵqud(402653184, 1, { entryPoint: 0 }), (_l()(), i0.ɵeld(1, 16777216, [[1, 3], ["entryPoint", 1]], null, 0, null, null, null, null, null, null, null)), (_l()(), i0.ɵeld(2, 0, null, null, 1, "fl-modal", [], [[2, "BackdropActive", null]], [[null, "click"], ["document", "keydown.escape"]], function (_v, en, $event) { var ad = true; if (("click" === en)) {
        var pd_0 = (i0.ɵnov(_v, 3).handleClick() !== false);
        ad = (pd_0 && ad);
    } if (("document:keydown.escape" === en)) {
        var pd_1 = (i0.ɵnov(_v, 3).handleEscape($event) !== false);
        ad = (pd_1 && ad);
    } return ad; }, i1.View_ModalComponent_0, i1.RenderType_ModalComponent)), i0.ɵdid(3, 245760, null, 0, i2.ModalComponent, [i3.ModalService, [1, i0.Injector]], null, null)], function (_ck, _v) { _ck(_v, 3, 0); }, function (_ck, _v) { var currVal_0 = i0.ɵnov(_v, 3).backdropActive; _ck(_v, 2, 0, currVal_0); }); }
export function View_CompatComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "webapp-compat", [], null, null, null, View_CompatComponent_0, RenderType_CompatComponent)), i0.ɵdid(1, 114688, null, 0, i4.CompatComponent, [[1, i0.Injector], i0.NgModuleFactoryLoader], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var CompatComponentNgFactory = i0.ɵccf("webapp-compat", i4.CompatComponent, View_CompatComponent_Host_0, {}, {}, []);
export { CompatComponentNgFactory as CompatComponentNgFactory };



// WEBPACK FOOTER //
// ./src/compat/compat.component.ngfactory.js.pre-build-optimizer.js